import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ResponsibleBanner from "@/components/ResponsibleBanner";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <ResponsibleBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
